import React from 'react';
import { makeStyles } from '@material-ui/core';
import {MyMess} from '../App' ;
import Link from '@material-ui/core/Link';

const useStyles = makeStyles((theme) => ({
    footer:{
        position: 'absolute',
        bottom: 15,
        right: 15,
        color: 'white'
    }
}))
export default function Footer() {
    const classes = useStyles();
    
   
    return (
        <div className={classes.footer}>
          &copy; KopaPro {` | `} 
          
          <Link color="inherit" href="https://kopapro.com/privacy-policy/">
                {MyMess.footer.privacyPolicy}
            </Link>
        {` | `}       
            <Link color="inherit" href="https://kopapro.com/terms-of-service/">
                {MyMess.footer.tos}
            </Link>     
          {` | `} 
            <Link color="inherit" href="https://kopapro.com/contact/">
                {MyMess.footer.contact}
            </Link>
        </div>
    )
}
